<ng-container *transloco="let t">
  @if (!isLoading) {
    <div class="flex flex-1 flex-col gap-4">
      <tui-stepper class="pointer-events-none mb-2" data-testid="stepper" [(activeItemIndex)]="activePageIndex">
        @for (step of telemonitoringRequestStepsConfig; track step.name) {
          <button tuiStep type="button">
            {{ t(step.name) }}
          </button>
        }
      </tui-stepper>
      <section
        class="min-h-80 flex-1 *:block *:pb-4"
        pxcSlidesScrollReset
        [formGroup]="form"
        [tuiSlides]="slideDirection">
        @switch (activePageIndex) {
          @case (TelemonitoringRequestStep.TYPE) {
            <pxc-telemonitoring-request-type data-testid="request-type" (creatorTypeChange)="pickCreatorType($event)" />
          }
          @case (TelemonitoringRequestStep.DETAILS) {
            <pxc-telemonitoring-request-details
              data-testid="request-details"
              [defaultName]="defaultName"
              [form]="form" />
          }
          @case (TelemonitoringRequestStep.COLLABORATORS) {
            <pxc-telemonitoring-collaborators
              formControlName="collaborators"
              [departmentIds]="form.get('departmentIds').value" />
          }
          @case (TelemonitoringRequestStep.LOCATION) {
            <pxc-telemonitoring-request-location data-testid="request-location" [form]="form" />
          }
          @case (TelemonitoringRequestStep.SEQUENCES) {
            <pxc-telemonitoring-request-sequences data-testid="request-sequences" [form]="form" />
          }
        }
      </section>
      <footer class="mt-auto!" tuiFloatingContainer>
        <div class="flex flex-wrap items-center gap-2 md:gap-4">
          @if (!telemonitoringRequestStepsConfig[activePageIndex].hidePrevious) {
            <button
              appearance="outline"
              class="mr-auto max-md:order-last max-md:w-full"
              data-testid="previous-button"
              tuiButton
              type="button"
              (click)="previousPage()">
              {{ activePageIndex < 1 ? t('Annuler') : t('Précédent') }}
            </button>
          }
          @if (!telemonitoringRequestStepsConfig[activePageIndex].hideNext) {
            <button
              class="max-md:w-full"
              data-testid="next-button"
              tuiButton
              type="button"
              [disabled]="!isStepValid(telemonitoringRequestStepsConfig[activePageIndex].fields)"
              (click)="nextPage()">
              {{ activePageIndex === telemonitoringRequestStepsConfig.length - 1 ? t('Créer') : t('Suivant') }}
            </button>
          }
        </div>
      </footer>
    </div>
  } @else {
    <pxc-telemonitoring-request-result [state]="state$ | async" (closeDialog)="closeDialog()" />
  }
</ng-container>
